import generalSettings from '@/config/general';
const VERSION = '0';
const PREFIX = 'common: services: localStorage: userInteractions:'; // Interactions should use true/false nomenclature

export const INTERACTIONS = {
  VIEWED_DATA_EDIT_MODAL: 'viewedDataEditModal',
  VIEWED_SELECT_MODAL: 'viewedSelectModal',
  UPDATED_WIDGET_WITH_FORM: 'updatedWidgetWithForm',
  DOWNLOADED_WIDGET_IMAGE: 'downloadedWidgetImage',
  DATA_EDITOR_FOOTER_COLLAPSED: 'dataEditorFooterCollapsed'
};
export default {
  saveValue(interactionName, value) {
    localStorage.setItem(createKey(interactionName), `${value}`);
    return value;
  },

  findValue(interactionName) {
    const payload = localStorage.getItem(createKey(interactionName));
    if (payload === null) return null;
    return payload.toLowerCase() === 'true';
  },

  removeValue(interactionName) {
    localStorage.removeItem(createKey(interactionName));
  }

};

function createKey(interactionName) {
  if (!Object.values(INTERACTIONS).includes(interactionName)) {
    throw new Error(`${PREFIX} Unsupported interaction name: "${interactionName}"`);
  }

  return `${generalSettings.productNameSpace}-${VERSION}-${interactionName}`;
}